import React from "react";
import { object } from "prop-types";
import { WithLazy } from "@quintype/components";

const FacebookVideo = ({ element }) => {
  return (
    <div className="facebook-video">
      <WithLazy>
        {() => (
          <iframe
            src={`https://www.facebook.com/plugins/video.php?href=${element.metadata["facebook-url"]}`}
            width="1000px"
            height="1000px"
            frameBorder="0"
            allowtransparency="true"
            allowFullScreen="true"
            scrolling="no"
            allow="encrypted-media"
            style={{ border: "none", visibility: "visible", width: "100%", height: "392px", overflow: "hidden" }}
            id="iFrameResizer0"
          />
        )}
      </WithLazy>
    </div>
  );
};

FacebookVideo.propTypes = {
  element: object,
};

export default FacebookVideo;
